import faker from 'faker';
import { sentenceCase } from 'change-case';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Table,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  CardHeader,
  Typography,
  TableContainer,
  LinearProgress,
  linearProgressClasses,
  Autocomplete,
  TextField,
  CircularProgress,
  TablePagination,
  Pagination,
  Tooltip,
} from '@material-ui/core';
// utils
import { fCurrency } from '../../../utils/formatNumber';
//
import Label from '../../Label';
import Scrollbar from '../../Scrollbar';
import React, { Fragment, useEffect , useState } from 'react';
import { empty } from 'src/Helpers/Common';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import moment from 'moment';
import { formatDateOnly } from 'src/utils/dateOnly';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';

// ----------------------------------------------------------------------

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  // Split into parts: strings and numbers
  const partsA = a.match(/(\d+|\D+)/g) || [];
  const partsB = b.match(/(\d+|\D+)/g) || [];

  // Compare each part
  const minLength = Math.min(partsA.length, partsB.length);
  for (let i = 0; i < minLength; i++) {
    const partA = partsA[i];
    const partB = partsB[i];

    // If both parts are numbers, compare numerically
    if (/^\d+$/.test(partA) && /^\d+$/.test(partB)) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      // Otherwise, compare as strings (case-insensitive)
      const strCompare = partA.localeCompare(partB, undefined, { sensitivity: 'base' });
      if (strCompare !== 0) {
        return strCompare;
      }
    }
  }

  // If all parts are equal, shorter string comes first
  return partsA.length - partsB.length;
}

  const  EcommerceBestSalesman = React.memo(() => {
  const navigate=useNavigate()
  const [page,setPage] = useState(1)
  const theme = useTheme();
  const [loading,setLoading] = useState(false)
  const [allProjects,setAllProjects]= useState([])
  const [totalCount,setTotalCount] = useState(0)
  const userData = JSON.parse(localStorage.getItem('user'))
  let isClient = userData?.isClient;
  let userType =isClient? 3 : userData?.user_type;
  let userId = userData?.user_id;

  if(userData.added_by_client && userData.parent_user_type && userData.parent_id) {
    userId = userData.parent_id
    userType =userData.parent_user_type
  }
 
const explodedPermissions = userData?.exploded_permissions;
const tabPermissions = {
  'Pre-Production': explodedPermissions?.some(p => p === 'View Pre Production Jobs') || false,
  'Production':     explodedPermissions?.some(p => p === 'View Production Jobs') || false,
  'Installs':       explodedPermissions?.some(p => p === 'View Installs Jobs') || false,
  'Pickup':         explodedPermissions?.some(p => p === 'View Pickup Jobs') || false,
  'Shipping':       explodedPermissions?.some(p => p === 'View Shipping Jobs') || false,
  'Completed':      explodedPermissions?.some(p => p === 'View Completed Jobs') || false,
};
const hasAnyTabPermission = Object.values(tabPermissions).some(v => v === true);

  const fetchAllProjects = async()=>{
    try {
       setLoading(true)
       const res = await axios.post(REST_API_END_POINT+'settings/project-upcoming',{
        all:true, page:page-1, userType,
          tabPermissions,           
  hasAnyTabPermission  ,
   userId })
       if(res){
         let budget = res?.data?.data?.results?.reduce((total, currentItem) => total + currentItem.cost, 0)?.toFixed(2);
         let expense = res?.data?.data?.results?.reduce((total, currentItem) => total + currentItem.expense, 0)?.toFixed(2);
         let Utilization = parseFloat((expense/budget)*100).toFixed(2)
         // Sort projects alphanumerically by name
         const sortedResults = [...(res?.data?.data.results || [])].sort((a, b) => 
           alphanumericCompare(a?.name || '', b?.name || '')
         );
         let permittedResults = sortedResults;
if (hasAnyTabPermission) {
  permittedResults = sortedResults.filter(job => {
    const s = Number(job.status ?? -1);
    if (s === 0 || s === 1) return tabPermissions['Pre-Production'];
    if (s !== 3)            return tabPermissions['Production'];
    if (s === 3)            return tabPermissions['Installs'] || tabPermissions['Pickup'] || tabPermissions['Shipping'];
    return false;
  });
}
         setAllProjects(permittedResults)
         setTotalCount(res?.data?.data.totalCount)
       }
    } catch (error) {
      console.log(error)
    } finally{
      setLoading(false)
    }
    
  }
  useEffect(()=>{
    fetchAllProjects()
   },[page,userType])
  const handleProjectByname=(value)=>{
    if(!empty(value)){
      setAllProjects([value])
    }else{
      fetchAllProjects()
    }
  }
  let progressValue 
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, 
    },
  }));
  const StickyTableHead = styled(TableHead)(({ theme }) => ({
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  }));

  return (
    <Card sx={{ pb: 3 }}>
      <CardHeader 
      title="Upcoming Deadlines" 
      action={
       <Autocomplete
           loading={loading}
           sx={{width:200}}
          id="combo-box-demo"
          options={(allProjects || []).sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          )}
          onChange={(event, newValue) =>{
            handleProjectByname(newValue)}
          }
          renderInput={(params) => (
            <TextField
            {...params}
             label="Upcoming Jobs"
             InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                  </Fragment>
              ),
            }}
            />
          )}
          getOptionLabel={(option) => option.name}

        />}
      sx={{ mb: 3 }} />
      <Scrollbar>
        <TableContainer
          sx={{
            minWidth: 520,
            whiteSpace: "nowrap",
            overflowX: "auto",
            maxHeight: "500px",  // Set a max height to allow scrolling
            overflowY: "auto",  // Enable vertical scrollbar
            '&::-webkit-scrollbar': {
              width: '0.6em',
              height: '0.6em',
            },
            '&::-webkit-scrollbar-track': {
              background: '#1e1e1e', // dark background to blend with dark UI
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#555', // medium-gray thumb
              borderRadius: '6px',
              border: '2px solid #1e1e1e', // contrast border to separate from track
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#888', // lighter on hover for feedback
            },
            '&::-webkit-scrollbar-corner': {
              backgroundColor: '#1e1e1e' // match your dark background
            },
          }}
        >
          <Table
            stickyHeader
            sx={{
              '& .MuiTableCell-head': {
                padding: '8px 12px',
                fontSize: '0.75rem',
                fontWeight: 600,
                height: '48px',
                minHeight: '48px',
                maxHeight: '48px',
                lineHeight: 1.4,
                whiteSpace: 'nowrap',
                textAlign: 'left',
                verticalAlign: 'middle'
              },
              '& .MuiTableSortLabel-root': {
                fontSize: '0.75rem',
                fontWeight: 600,
                justifyContent: 'flex-start',
                '& .MuiTableSortLabel-icon': {
                  marginLeft: '4px'
                }
              }
            }}
          >
            <StickyTableHead>
              <TableRow>
                <TableCell>Job</TableCell>
                <TableCell>Deadline</TableCell>
                <TableCell>Progress</TableCell>              
              </TableRow>
            </StickyTableHead>
            <TableBody>
              {allProjects?.map((row) =>{
                progressValue=row.completion
                return(
                <TableRow 
                  key={row.name}
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '8px 12px',
                      fontSize: '0.75rem',
                      height: 'auto',
                      lineHeight: 1.4
                    }
                  }}
                >
                  <TableCell align="left" sx={{ padding: '8px 12px' }}>
                    <Tooltip title={row.name}>
                      <Typography 
                        onClick={()=>{ userType === 3 ? navigate(PATH_DASHBOARD.official.viewRequest.replace(':id', row.request_id)) :navigate(PATH_DASHBOARD.project.viewproject+row.id) }} 
                        variant="subtitle2" 
                        sx={{ 
                          color: 'text.primary', 
                          cursor: 'pointer',
                          maxWidth: 200,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontSize: '0.75rem',
                          fontWeight: 500
                        }}
                      > 
                        {row.name}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '8px 12px' }}> 
                    <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                      {row.installation_start_date && row.installation_end_date 
                        ? `${formatDateOnly(row.installation_start_date)} - ${formatDateOnly(row.installation_end_date)}`
                        : formatDateOnly(row.installation_date)
                      }
                    </Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '8px 12px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BorderLinearProgress variant="determinate" value={row.completion} sx={{ flex: 1 }} />
                      <Typography variant="body2" sx={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                        {row.completion}{'%'} Completed
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Pagination
        count={Math.ceil(totalCount / 10)}
        onChange={(event, value) => setPage(value)}
        />
      </Box>
    </Card>
  );
});

export default EcommerceBestSalesman;
